var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineTicketExpired(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.91 20.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6.47c3.06 0 3.78-.5 3.86-3.22a3.067 3.067 0 0 1-2.3-2.96c0-1.43.98-2.64 2.31-2.98v-.26c0-3.29-.58-3.87-3.87-3.87h-5.63V12c0 .41-.34.75-.75.75s-.75-.34-.75-.75V5.21c0-.41.34-.75.75-.75h6.38c4.12 0 5.37 1.25 5.37 5.37v.92c0 .41-.34.75-.75.75-.86 0-1.56.7-1.56 1.57 0 .86.7 1.56 1.56 1.56.41 0 .75.34.75.75 0 4.12-1.25 5.37-5.37 5.37h-6.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23 20.75c-2.02 0-3.06-1.52-4.01-3.8l-.19-.46a.75.75 0 0 1 .42-.97c.4-.16.71-.47.88-.86.17-.4.17-.84 0-1.24-.33-.84-1.28-1.23-2.12-.9-.19.08-.39.07-.58-.01a.764.764 0 0 1-.4-.41l-.17-.43c-1.6-3.89-.9-5.56 2.99-7.17l2.64-1.08c.38-.16.82.03.98.41l3.03 7.34c.04.09.06.19.06.29V14c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-2.4l-2.7-6.51-1.94.8c-3.08 1.27-3.45 2.05-2.24 5.05 1.39-.2 2.79.55 3.34 1.9.32.77.32 1.62-.01 2.39-.22.53-.58.98-1.04 1.31.96 2.26 1.66 2.71 2.55 2.71h2.02V17c0-.41.34-.75.75-.75s.75.34.75.75v3a.74.74 0 0 1-.74.75H8.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 20.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h.17c.41 0 .75.34.75.75s-.34.75-.75.75H8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTicketExpired);
export default __webpack_public_path__ + "static/media/vuesax-outline-ticket-expired.16ec609f11d1b94eba1a17bfce97993f.svg";
export { ForwardRef as ReactComponent };